import {
  AfterViewInit,
  Directive,
  ElementRef
} from '@angular/core';

@Directive({
  selector: '[give-focus]'
})
export class GiveFocusDirective implements AfterViewInit {
  constructor ( private el: ElementRef ) {}

  ngAfterViewInit () : void {
    setTimeout(() => {
      this.el.nativeElement.focus({ preventScroll: true });
    });
  }
}
